import type { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function SearchIcon({ size = 24, className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path
        d="M21.5318 20.4696L16.8378 15.7765C18.1983 14.1431 18.8767 12.048 18.7319 9.92715C18.5871 7.80629 17.6302 5.82289 16.0603 4.38956C14.4904 2.95623 12.4284 2.18333 10.3031 2.23163C8.17785 2.27993 6.15303 3.14571 4.64986 4.64888C3.14669 6.15205 2.2809 8.17687 2.2326 10.3021C2.1843 12.4274 2.95721 14.4894 4.39054 16.0593C5.82387 17.6293 7.80726 18.5861 9.92813 18.7309C12.049 18.8757 14.144 18.1973 15.7774 16.8368L20.4706 21.5308C20.5403 21.6005 20.623 21.6558 20.714 21.6935C20.8051 21.7312 20.9026 21.7506 21.0012 21.7506C21.0997 21.7506 21.1973 21.7312 21.2884 21.6935C21.3794 21.6558 21.4621 21.6005 21.5318 21.5308C21.6015 21.4612 21.6568 21.3784 21.6945 21.2874C21.7322 21.1963 21.7516 21.0988 21.7516 21.0002C21.7516 20.9017 21.7322 20.8041 21.6945 20.713C21.6568 20.622 21.6015 20.5393 21.5318 20.4696ZM3.75119 10.5002C3.75119 9.16519 4.14707 7.86015 4.88877 6.75011C5.63047 5.64008 6.68468 4.77492 7.91808 4.26403C9.15148 3.75314 10.5087 3.61946 11.8181 3.87991C13.1274 4.14036 14.3302 4.78324 15.2742 5.72724C16.2182 6.67125 16.861 7.87398 17.1215 9.18335C17.3819 10.4927 17.2483 11.8499 16.7374 13.0833C16.2265 14.3167 15.3613 15.3709 14.2513 16.1126C13.1413 16.8543 11.8362 17.2502 10.5012 17.2502C8.71159 17.2482 6.99585 16.5364 5.73041 15.271C4.46497 14.0056 3.75318 12.2898 3.75119 10.5002Z"
        fill="currentColor"
      />
    </svg>
  );
}
